import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { faCircleNotch } from '@fortawesome/pro-solid-svg-icons'
import React, { CSSProperties, FC, useState } from 'react'

import {
  CustomIcon,
  FicButton,
  LeftWrapper,
  Link,
  RightWrapper,
} from './common.components'
import { ButtonType, Size, Target } from './common.types'

interface Props {
  customClass?: string
  type?: ButtonType
  href?: string
  iconLeft?: IconDefinition
  iconRight?: IconDefinition
  isDisabled?: boolean
  isLoading?: boolean
  onClick?: (event?: React.MouseEvent) => void
  reloadPage?: boolean
  size?: Size
  style?: CSSProperties
  target?: Target
  text?: string
  isFeedback?: boolean
}

export const Button: FC<Props> = ({
  customClass,
  href,
  iconLeft,
  iconRight,
  isDisabled,
  isFeedback,
  isLoading,
  onClick,
  reloadPage,
  size,
  style,
  target,
  text,
  type,
}: Props) => {
  const [clickable, setClickable] = useState<boolean>(true)
  const className =
    'fic-' +
    type +
    '-button' +
    (type == 'text' ? ' btn-flat' : '') +
    ' primary ' +
    (size ?? 'large') +
    (isDisabled ? ' btn-disabled ' : '') +
    (isLoading ? ' btn-loading ' : '') +
    (customClass ? ' ' + customClass : '') +
    (reloadPage ? '' : ' ajax-link')

  const showIconLeft = (
    <>
      {(isLoading || iconLeft) && (
        <LeftWrapper hasText={!!text && !isLoading}>
          <CustomIcon
            fixedWidth
            icon={isLoading ? faCircleNotch : iconLeft}
            type={type}
            spin={isLoading}
          />
        </LeftWrapper>
      )}
    </>
  )

  const showIconRight = (
    <>
      {iconRight && (
        <RightWrapper hasText={!!text}>
          <CustomIcon fixedWidth icon={iconRight} type={type} />
        </RightWrapper>
      )}
    </>
  )

  const clickHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!reloadPage) event.preventDefault()
    if (!clickable || isLoading || isDisabled) {
      return
    }
    setClickable(false)
    setTimeout(() => {
      setClickable(true)
    }, 500)
    if (onClick) {
      onClick()
    }
    event.stopPropagation()
  }

  const simpleButton = type === 'link' || type == 'action' || type == 'facebook'
  return (
    <>
      {simpleButton && (
        <Link
          size={size}
          text={text}
          isDisabled={isDisabled}
          isLoading={isLoading}
          className={
            type == 'link' || type == 'action' ? 'ajax-link' : className
          }
          href={!isDisabled ? href : undefined}
          onClick={(event) => clickHandler(event)}
          target={target}
          style={style}
        >
          {showIconLeft}
          {!isLoading && text !== '' && text}
          {showIconRight}
        </Link>
      )}
      {!simpleButton && (
        <FicButton
          isFeedback={isFeedback}
          className={className}
          text={text}
          isDisabled={isDisabled}
          isLoading={isLoading}
          href={!isDisabled ? href : undefined}
          onClick={(event) => clickHandler(event)}
          target={target}
          style={style}
        >
          {showIconLeft}
          {!isLoading && text !== '' && text}
          {showIconRight}
        </FicButton>
      )}
    </>
  )
}

Button.defaultProps = {
  customClass: undefined,
  size: 'large',
  type: 'simple',
  href: undefined,
  target: undefined,
  onClick: undefined,
  style: undefined,
  isDisabled: false,
  isLoading: false,
  text: undefined,
}
